import Base from './base'

export default class Actions extends Base {
  async changeDue(activityId, date) {
    return this.api.post(`actions/${activityId}/pause.json`, {
      due_on: date.toString(),
    })
  }
}
